import React from 'react';
import { MediaPicker } from '@components/common/MediaPicker';
import { DEFAULT_FILE_MANAGER_UPLOAD_CONFIG } from '@const/media-upload.const';

const MediaContainer: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <MediaPicker
        uploadConfig={DEFAULT_FILE_MANAGER_UPLOAD_CONFIG}
        multiple={true}
        showPreview={true}
        showDownload={false}
        allowDirectoryCreation={true}
        height={600}
      />
    </div>
  );
};

export default MediaContainer;
